import { getApiUrl } from '../../utils/config';
import { useRestQuery } from '../wrappers';
const createSharedLessonQuery = async (sharingToken) => {
    return fetch(`${getApiUrl()}/api/v1/shared/lesson/${sharingToken}`);
};
export const useSharedLessonQuery = () => {
    return useRestQuery(createSharedLessonQuery);
};
